// extracted by mini-css-extract-plugin
export default {"wrapper":"FxQwD","title":"RPmgE","bonusTypes":"phFlk","type":"qBiKD","top":"PWtf6","image":"m81Y8","subtitle":"qo4Ar","points":"gDEZg","point":"BcgOJ","link":"VlvdJ"};